import React from 'react';
import './Drawer.css';
import { useAppThemeContext } from '../../contexts';

function Drawer({ title, isOpen, closeDrawer, children }) {

  const { themeName } = useAppThemeContext();

  return (
    <>
      {isOpen && <div className="drawer-backdrop" onClick={closeDrawer}></div>}
      <div className={`drawer ${themeName} ${isOpen ? 'open' : ''}`}>
        <div className="drawer-content">
          <span className="drawer-title">{title}</span>
          <span className='drawer-close fa fa-times' onClick={closeDrawer} />
          {children}
        </div>
      </div>
    </>
  );
}

export default Drawer;
